import { create } from "zustand";

const useDroneStore = create((set) => ({
    showDroneQrCode: false,
    setShowDroneQrCode: (bool) => {
        set({ showDroneQrCode: bool })
    },
    droneImgToView: "",
    setDroneImgToView: (link) => {
        set({ droneImgToView: link })
    },
    allPilots: [""],
    setAllPilots: (pilots) => {
        set({ allPilots: pilots })
    },
    showPilotModel: false,
    setShowPilotModal: (pilot) => {
        set({ showPilotModel: pilot })
    }
}))

export default useDroneStore;
